// fixes charts that sometimes initially render too wide - https://stackoverflow.com/a/1818513/595962
// Previously an inline <script> at the bottom of the body layouts; moved here so it
// is covered by the script-src 'self' CSP directive instead of tripping a violation.
$(() => $(window).trigger('resize'));
